/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Time object.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 * @author Víctor Díaz <victor@axiomer.com>
 * @author Fran Torregrosa <fran@axiomer.com>
 */
var Time = {
	init: function () {
		moment.locale(Language.code);
		
		if(Language.code === 'es') {
			Time.date_short = '[el] D [de] MMMM [a las] HH:mm';
			Time.date_long = '[el] D [de] MMMM [de] YYYY [a las] HH:mm';
		} else {
			Time.date_short = '[on] MMMM Do [at] HH:mm';
			Time.date_long = '[on] MMMM Do, YYYY [at] HH:mm';
		}
	},
	
	toString: function (timestamp) {
		var now = moment();
		var then = moment.unix(timestamp);
		
		if (Math.abs(then.diff(now, 'hours')) <= 22)
			return then.fromNow();
		
		if (then.isSame(now.clone().subtract(1, 'days'), 'day') || then.isSame(now, 'day') || then.isSame(now.clone().add(1, 'days'), 'day'))
			return then.calendar();
		
		if (then.isSame(now, 'year'))
			return then.format(Time.date_short);
		
		return then.format(Time.date_long);
	},
	
	getHTML: function (timestamp) {
		var then = moment.unix(timestamp);
		
		return '<time datetime="' + then.toISOString() + '" title="' + then.format(Time.date_long) + '" data-timestamp="' + timestamp + '">' + Time.toString(timestamp) + '</time>';
	},
	
	getDayName: function (number) {
		return moment().weekday(number).format('dddd');
	},
	
	getMonthName: function (number) {
		return moment().month(number).format('MMMM');
	}
};